import './index.css'
import { Descriptions, Space } from 'antd'
import CIMSBasicFields from 'components/CIMSBasicFields'
import type { ExpandedRecordProps } from './types'

/** Presents configured fields and custom sections beneath a workflow row. */
function ExpandedRecord({ additionalInfo, sections }: ExpandedRecordProps) {
  return (
    <Space direction="vertical" size="middle">
      {additionalInfo && (
        <div className="workflow-record-additional-info">
          <CIMSBasicFields title="Additional Info" fields={additionalInfo} />
        </div>
      )}
      {sections.map((section) => (
        <Descriptions key={section.key} size="small" column={1}>
          <Descriptions.Item>{section.children}</Descriptions.Item>
        </Descriptions>
      ))}
    </Space>
  )
}

export default ExpandedRecord
